import { Button, Popper, styled } from "@mui/material";

export const StyledActions = {
  Container: styled("div")(({ theme }) => ({
    display: "flex",
    color: "gray",
    fontFamily: "Roboto, sans-serif",
    fontSize: "10px",
    fontWeight: "bold",
  })),
  Button: styled(Button)(({ theme }) => ({
    marginRight: "10px",
  })),
  ThirdButton: styled(Button)(({ theme }) => ({
    marginLeft: "10px",
  })),
};

export const StyledAutocomplete = {
  NoOptionTextLabel: styled('div')(({ theme }) => ({
    color: theme.palette.grey[600],
    padding: theme.spacing(2),
  })),
  AutocompletePopper: styled(Popper)(({ theme, width }) => ({
    width: width,
    zIndex: theme.zIndex.tooltip,
  })),
  ShowMoreButtonContainer: styled('div')(({ theme }) => ({
    textAlign: "center",
    padding: 8
  })),
}